const validateStepFields = (step) => {
	var stepWrapper = document.querySelector('.account-form-step-js:nth-child('+step+')')
	var stepValid = true;
	var fields = stepWrapper.querySelectorAll('.form-input[required]');
	fields.forEach((field) => {
		if (field.id === 'onboarding_email' && field.parentElement.classList.contains('has-danger')) {
			stepValid = false;
		} else {
			if (field.value === '') {
				stepValid = false;
				field.parentElement.classList.add('has-danger');
			} else {
				field.parentElement.classList.remove('has-danger');
			}
		}
	})

	return stepValid;
};

function checkEmailAvailability (email) {
	reservationsApi.checkEmailAvailability(email, handleEmailResponse);
}


function handleEmailResponse(data){
	setEmailError(data)
	resetClang()
	setClangMailLetter(data)
}
function resetClang(){
	document.querySelector('#mailing-box').style.display = 'block'
	document.querySelector('#id_optin').checked = true
	document.querySelector('#id_editorial').value = 'true'
	document.querySelector('#id_magazine').value = 'true'
	document.querySelector('#id_special').value = 'true'
	document.querySelector('#id_newsletter').value = 'true'
	document.querySelector('#id_partner_mailing').value = 'true'
	document.querySelector('#id_sms').value = 'true'
}
function setClangMailLetter(data){

	var mailing_box = document.querySelector('#mailing-box')
	if(!data['clang']){
		mailing_box.style.display = 'block'
		return
	}
	var clang = data['clang']
	//optin in a checkbox

	var optin = document.querySelector('#id_optin')
	var editorial = document.querySelector('#id_editorial')
	var magazine = document.querySelector('#id_magazine')
	var special = document.querySelector('#id_special')
	var newsletter = document.querySelector('#id_newsletter')
	var partner = document.querySelector('#id_partner_mailing')
	var sms = document.querySelector('#id_sms')

	if(clang['optin']){
		//keep the display hidden but keep it check the checkbox
		mailing_box.style.display = 'none'
		optin.checked = 'checked'
	}else{
		//
		mailing_box.style.display = 'block'
	}
	editorial.value = clang['editorial']
	magazine.value = clang['magazine']
	special.value = clang['special']
	newsletter.value = clang['newsletter']
	partner.value = clang['partner_mailing']
	sms.valeue = clang['sms']

}

function setEmailError(data) {
	var emailErrors = document.querySelector('.email-errors-js');
	if (data.email !== undefined) {
		emailErrors.innerHTML = data.email[0];
		emailErrors.parentElement.classList.add('has-danger');
	} else if (data.is_available) {
		emailErrors.innerHTML = '';
		emailErrors.parentElement.classList.remove('has-danger');
	} else {
		emailErrors.innerHTML = 'Je e-mailadres is al bij ons bekend. Heb je nog geen wachtwoord of ben je deze vergeten?<br /><a href="/profiel/wachtwoord-reset/" class="emailTakenForgotPasswordLink">Vraag een wachtwoord aan.</a>';
		emailErrors.parentElement.classList.add('has-danger');
	}
}

const changeAccountFormStep = (change, type) => {
	const stepWrapper = document.querySelector('.account-form-wrapper-js');
	const currentStep = stepWrapper.dataset.activeStep;
	let newStep = 0;
	const stepPages = Array.from(document.querySelectorAll('.step-js'));
	if (type !== 'subtract') {
		var stepValid = validateStepFields(currentStep);

		if (!stepValid) {
			return false;
		}
	}

	if ((parseInt(currentStep, 10) < stepPages.length && type === 'add') ||
		(parseInt(currentStep, 10) > 0 && type === 'subtract') ||
		type === 'set') {
		const currentPage = document.querySelector('.step--active');
		currentPage.classList.remove('step--active');
		if (type === 'add') {
			newStep = parseInt(currentStep, 10) + parseInt(change, 10);
		} else if (type === 'subtract') {
			newStep = parseInt(currentStep, 10) - parseInt(change, 10);
		} else if (type === 'set') {
			newStep = change;
		}
		const translate = (newStep * 100) - 100;
		stepPages[newStep - 1].classList.add('step--active');
		stepWrapper.setAttribute('data-active-step', newStep);

		const steps = Array.from(document.querySelectorAll('.account-form-step-js'));
		steps.forEach((step) => {
			step.style.transform = `translateX(-${translate}%)`;
		});
	}
};

const prefillAddress = (data) => {
	const street = document.querySelector('.street-js');
	const city = document.querySelector('.city-js');

	if (data.street !== undefined) {
		street.value = data.street;
	}else{
		street.value = ''
	}

	if (data.city !== undefined) {
		city.value = data.city;
	}else{
		city.value = ''
	}
};


const fetchAddress = () => {
	const postalCode = document.querySelector('.postal-code-js').value;
	const houseNumber = document.querySelector('.house-number-js').value;
	const suffix = document.querySelector('.suffix-js').value;
	const country = document.querySelector('.country-js').value;
	const filters = {
		postal_code: postalCode,
		number: houseNumber,
		suffix: suffix,
	};

	if (postalCode !== undefined && postalCode !== '' &&
		houseNumber !== undefined && houseNumber !== '' &&
		country === 'Nederland'
	) {
		reservationsApi.fetchAddress(prefillAddress, filters);
	}
};

document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.postal-code-js')) {
		document.querySelector('.postal-code-js').addEventListener('change', () => {
			fetchAddress();
		});
	}
	if (document.querySelector('.house-number-js')) {
		document.querySelector('.house-number-js').addEventListener('change', () => {
			fetchAddress();
		});
	}
	if (document.querySelector('.suffix-js')) {
		document.querySelector('.suffix-js').addEventListener('change', () => {
			fetchAddress();
		});
	}
	if (document.querySelector('.country-js')) {
		document.querySelector('.country-js').addEventListener('change', () => {
			fetchAddress();
		});
	}
	if (document.querySelector('.account-form-wrapper-js')) {
		const formInputs = Array.from(document.querySelectorAll('.account-form-wrapper-js input'));
		formInputs.forEach((input) => {
			input.addEventListener('keypress', (e) => {
				const key = e.which || e.keyCode;
				if (key === 13) {
					e.preventDefault();
					changeAccountFormStep(1, 'add');
				}
			});
		});
	}
});
